import { render } from "./PlayContainer.vue?vue&type=template&id=414bc8bc&ts=true"
import script from "./PlayContainer.vue?vue&type=script&lang=ts"
export * from "./PlayContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/apprelax.webweb.works/client/apprelax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__